// components/StatusBadge.jsx
import React from "react";

const statusStyles = {
  new: {
    text: "NEW",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  Saved: {
    text: "SAVED",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  completed: {
    text: "CMP",
    bgColor: "bg-[#e6f4ea]",       // softer greenish success background
    textColor: "text-[#1b5e20]",    // deep green for good contrast
    border: "border-[#c8e6c9]",     // light green border (optional)
  },
  
  "spot-quote requested": {
    text: "SQR",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  "spot QQ requested": {
    text: "SQQR",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  "Draft Quick Quote": {
    text: "DQQ",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  "Quick Quoted": {
    text: "QQ",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  pending: {
    text: "PND",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  quoted: {
    text: "QUOTED",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  rejected: {
    text: "REJECTED",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  archived: {
    text: "ARCHIVED",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  Expired: {
    text: "EXPIRED",
    bgColor: "bg-[#dee3ed]",
    textColor: "text-[#202a41]",
    border: "border-[#5f6e91]",
  },
  "no quote": {
    text: "NQ",
    bgColor: "bg-[#ffebfa]",
    textColor: "text-[#670f51]",
    border: "border-[#bb2a97]",
  },
  "no quick quote": {
    text: "NQQ",
    bgColor: "bg-[#ffebfa]",
    textColor: "text-[#670f51]",
    border: "border-[#bb2a97]",
  },
  tender: {
    text: "TD",
    bgColor: "bg-[#e1f6fe]",
    textColor: "text-[#05455c]",
    border: "border-[#0877a0]",
  },
  booked: {
    text: "BKD",
    bgColor: "bg-[#e1f6fe]",
    textColor: "text-[#05455c]",
    border: "border-[#0877a0]",
  },
  "in transit": {
    text: "IN-T",
    bgColor: "bg-[#efe5ff]",
    textColor: "text-[#35126e]",
    border: "border-[#6735b8]",
  },
  delivered: {
    text: "DD",
    bgColor: "bg-[#e4f6ed]",
    textColor: "text-[#054324]",
    border: "border-[#0c693b]",
  },
  "invoice paid": {
    text: "IP",
    bgColor: "bg-[#e4f6ed]",
    textColor: "text-[#054324]",
    border: "border-[#0c693b]",
  },
  "invoice created": {
    text: "IC",
    bgColor: "bg-[#ffe7bd]",
    textColor: "text-[#7a2d00]",
    border: "border-[#ba580d]",
  },
  "invoice sent": {
    text: "IS",
    bgColor: "bg-[#ffe7bd]",
    textColor: "text-[#7a2d00]",
    border: "border-[#ba580d]",
  },
  cancelled: {
    text: "CAN",
    bgColor: "bg-[#fdecef]",
    textColor: "text-[#7e0c1e]",
    border: "border-[#d32742]",
  },
};

const StopStatus = ({ status }) => {
  const key = String(status || "").toLowerCase();

  const style = statusStyles[key] || {
    text: String(status)?.toUpperCase() || "UNK",
    bgColor: "bg-gray-100",
    textColor: "text-gray-800",
    border: "border-gray-400",
  };

  return (
    <span
      className={`flex items-center justify-center  text-xs font-semibold rounded border ${style?.bgColor} ${style?.textColor} ${style?.border}`}
      style={{ width: "auto", height: "24px",padding:"0px 3px" }}
    >
      {style?.text}
    </span>
  );
};

export default StopStatus;
